import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ILightboxSchema, IPreviewFile } from './types';

const initialState: ILightboxSchema = {
    currentFileId: null,
    files: [],
    currentFile: null,
};

export const lightboxSlice = createSlice({
    name: 'lightboxSlice',
    initialState,
    reducers: {
        onChangeFile: (state, { payload }: PayloadAction<number>) => {
            state.currentFileId = payload;
            state.currentFile = state.files.find((file) => file.id === payload);
        },
        onShow: (
            state,
            action: PayloadAction<{
                currentFileId: number | string;
                files: IPreviewFile[];
            }>
        ) => {
            state.currentFileId = action.payload.currentFileId;
            state.files = action.payload.files;
            state.currentFile = state.files.find(
                (file) => file.id === action.payload.currentFileId
            );
        },
        onClose: (state) => {
            state.currentFileId = null;
            state.files = [];
            state.currentFile = null;
        },
    },
});

export const { actions: lightboxSliceActions } = lightboxSlice;
export const { reducer: lightboxSliceReducer } = lightboxSlice;
